/* tslint:disable */
/* eslint-disable */
/**
 * Your API Title
 * Your API Description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface Account
 */
export interface Account {
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    'accountName': string;
    /**
     * 
     * @type {number}
     * @memberof Account
     */
    'balance': number;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface Apikey
 */
export interface Apikey {
    /**
     * 
     * @type {number}
     * @memberof Apikey
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof Apikey
     */
    'userID': number;
    /**
     * 
     * @type {string}
     * @memberof Apikey
     */
    'appName': string;
    /**
     * 
     * @type {string}
     * @memberof Apikey
     */
    'apiKey': string;
    /**
     * 
     * @type {string}
     * @memberof Apikey
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof Apikey
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface AuthParam
 */
export interface AuthParam {
    /**
     * 
     * @type {string}
     * @memberof AuthParam
     */
    'accessToken': string;
}
/**
 * 
 * @export
 * @interface Block
 */
export interface Block {
    /**
     * 
     * @type {number}
     * @memberof Block
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof Block
     */
    'blockHash': string;
    /**
     * 
     * @type {string}
     * @memberof Block
     */
    'producer': string;
    /**
     * 
     * @type {number}
     * @memberof Block
     */
    'txCount': number;
    /**
     * 
     * @type {string}
     * @memberof Block
     */
    'timestamp': string;
    /**
     * 
     * @type {number}
     * @memberof Block
     */
    'cpuUsage': number;
    /**
     * 
     * @type {number}
     * @memberof Block
     */
    'fee': number;
    /**
     * 
     * @type {string}
     * @memberof Block
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface ChartDataDto
 */
export interface ChartDataDto {
    /**
     * 
     * @type {string}
     * @memberof ChartDataDto
     */
    'category': string;
    /**
     * 
     * @type {number}
     * @memberof ChartDataDto
     */
    'totalCount': number;
}
/**
 * 
 * @export
 * @interface Contract
 */
export interface Contract {
    /**
     * 
     * @type {number}
     * @memberof Contract
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof Contract
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Contract
     */
    'creator': string;
    /**
     * 
     * @type {string}
     * @memberof Contract
     */
    'code': string;
    /**
     * 
     * @type {boolean}
     * @memberof Contract
     */
    'verified': boolean;
    /**
     * 
     * @type {string}
     * @memberof Contract
     */
    'sourcePath'?: string;
    /**
     * 
     * @type {string}
     * @memberof Contract
     */
    'abiPath'?: string;
    /**
     * 
     * @type {string}
     * @memberof Contract
     */
    'sourceStructure'?: string;
    /**
     * 
     * @type {string}
     * @memberof Contract
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof Contract
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface CreateApikeyDto
 */
export interface CreateApikeyDto {
    /**
     * 
     * @type {string}
     * @memberof CreateApikeyDto
     */
    'accessToken': string;
    /**
     * 
     * @type {string}
     * @memberof CreateApikeyDto
     */
    'appName': string;
}
/**
 * 
 * @export
 * @interface CreateDeveloperDto
 */
export interface CreateDeveloperDto {
    /**
     * 
     * @type {string}
     * @memberof CreateDeveloperDto
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDeveloperDto
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDeveloperDto
     */
    'email': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDeveloperDto
     */
    'subscribeNewsletter': boolean;
}
/**
 * 
 * @export
 * @interface CreateWatchAddressDto
 */
export interface CreateWatchAddressDto {
    /**
     * 
     * @type {string}
     * @memberof CreateWatchAddressDto
     */
    'accessToken': string;
    /**
     * 
     * @type {string}
     * @memberof CreateWatchAddressDto
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof CreateWatchAddressDto
     */
    'description': string;
    /**
     * 
     * @type {number}
     * @memberof CreateWatchAddressDto
     */
    'notificationType': number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateWatchAddressDto
     */
    'trackERC20Transfer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateWatchAddressDto
     */
    'trackERC721Transfer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateWatchAddressDto
     */
    'trackERC1155Transfer': boolean;
}
/**
 * 
 * @export
 * @interface DeveloperInfo
 */
export interface DeveloperInfo {
    /**
     * 
     * @type {number}
     * @memberof DeveloperInfo
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof DeveloperInfo
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof DeveloperInfo
     */
    'email': string;
    /**
     * 
     * @type {boolean}
     * @memberof DeveloperInfo
     */
    'subscribeNewsletter': boolean;
    /**
     * 
     * @type {string}
     * @memberof DeveloperInfo
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof DeveloperInfo
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface GetAccounts200Response
 */
export interface GetAccounts200Response {
    /**
     * 
     * @type {Array<Account>}
     * @memberof GetAccounts200Response
     */
    'accounts'?: Array<Account>;
    /**
     * 
     * @type {number}
     * @memberof GetAccounts200Response
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface GetBlocks200Response
 */
export interface GetBlocks200Response {
    /**
     * 
     * @type {Array<Block>}
     * @memberof GetBlocks200Response
     */
    'blocks'?: Array<Block>;
    /**
     * 
     * @type {number}
     * @memberof GetBlocks200Response
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface GetKeys200Response
 */
export interface GetKeys200Response {
    /**
     * 
     * @type {Array<Apikey>}
     * @memberof GetKeys200Response
     */
    'keys'?: Array<Apikey>;
    /**
     * 
     * @type {number}
     * @memberof GetKeys200Response
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface GetLastLoggedInHistory200Response
 */
export interface GetLastLoggedInHistory200Response {
    /**
     * 
     * @type {Array<LoginHistory>}
     * @memberof GetLastLoggedInHistory200Response
     */
    'history'?: Array<LoginHistory>;
    /**
     * 
     * @type {number}
     * @memberof GetLastLoggedInHistory200Response
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface GetTokens200Response
 */
export interface GetTokens200Response {
    /**
     * 
     * @type {Array<Token>}
     * @memberof GetTokens200Response
     */
    'tokens'?: Array<Token>;
    /**
     * 
     * @type {number}
     * @memberof GetTokens200Response
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface GetTransactions200Response
 */
export interface GetTransactions200Response {
    /**
     * 
     * @type {Array<Transaction>}
     * @memberof GetTransactions200Response
     */
    'txs'?: Array<Transaction>;
    /**
     * 
     * @type {number}
     * @memberof GetTransactions200Response
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface GetWatchAddresses200Response
 */
export interface GetWatchAddresses200Response {
    /**
     * 
     * @type {Array<WatchAddress>}
     * @memberof GetWatchAddresses200Response
     */
    'addresses'?: Array<WatchAddress>;
    /**
     * 
     * @type {number}
     * @memberof GetWatchAddresses200Response
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface LoginDeveloperDto
 */
export interface LoginDeveloperDto {
    /**
     * 
     * @type {string}
     * @memberof LoginDeveloperDto
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof LoginDeveloperDto
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface LoginHistory
 */
export interface LoginHistory {
    /**
     * 
     * @type {number}
     * @memberof LoginHistory
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof LoginHistory
     */
    'userID': number;
    /**
     * 
     * @type {string}
     * @memberof LoginHistory
     */
    'loggedIn': string;
    /**
     * 
     * @type {string}
     * @memberof LoginHistory
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof LoginHistory
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface Quote
 */
export interface Quote {
    /**
     * 
     * @type {number}
     * @memberof Quote
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof Quote
     */
    'token': string;
    /**
     * 
     * @type {string}
     * @memberof Quote
     */
    'base': string;
    /**
     * 
     * @type {number}
     * @memberof Quote
     */
    'marketCapPrice': number;
    /**
     * 
     * @type {number}
     * @memberof Quote
     */
    'marketCapVolumn': number;
    /**
     * 
     * @type {number}
     * @memberof Quote
     */
    'marketCapRisePercentage': number;
    /**
     * 
     * @type {string}
     * @memberof Quote
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface RemoveApikeyDto
 */
export interface RemoveApikeyDto {
    /**
     * 
     * @type {string}
     * @memberof RemoveApikeyDto
     */
    'accessToken': string;
    /**
     * 
     * @type {number}
     * @memberof RemoveApikeyDto
     */
    'id': number;
}
/**
 * 
 * @export
 * @interface RemoveWatchAddressDto
 */
export interface RemoveWatchAddressDto {
    /**
     * 
     * @type {string}
     * @memberof RemoveWatchAddressDto
     */
    'accessToken': string;
    /**
     * 
     * @type {number}
     * @memberof RemoveWatchAddressDto
     */
    'id': number;
}
/**
 * 
 * @export
 * @interface Signin200Response
 */
export interface Signin200Response {
    /**
     * 
     * @type {string}
     * @memberof Signin200Response
     */
    'sessionKey'?: string;
    /**
     * 
     * @type {number}
     * @memberof Signin200Response
     */
    'userID'?: number;
    /**
     * 
     * @type {string}
     * @memberof Signin200Response
     */
    'userEmail'?: string;
}
/**
 * 
 * @export
 * @interface Token
 */
export interface Token {
    /**
     * 
     * @type {number}
     * @memberof Token
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof Token
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Token
     */
    'issuer': string;
    /**
     * 
     * @type {number}
     * @memberof Token
     */
    'totalSupply': number;
    /**
     * 
     * @type {number}
     * @memberof Token
     */
    'precision': number;
    /**
     * 
     * @type {boolean}
     * @memberof Token
     */
    'verified': boolean;
    /**
     * 
     * @type {string}
     * @memberof Token
     */
    'timestamp': string;
    /**
     * 
     * @type {string}
     * @memberof Token
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface Transaction
 */
export interface Transaction {
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    'txId': string;
    /**
     * 
     * @type {number}
     * @memberof Transaction
     */
    'blockNum': number;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    'account': string;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    'actionName': string;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    'sender': string;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    'receiver': string;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    'contract': string;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    'token': string;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    'data': string;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    'swapToken': string;
    /**
     * 
     * @type {number}
     * @memberof Transaction
     */
    'swapAmount': number;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    'swapId': string;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    'timestamp': string;
    /**
     * 
     * @type {number}
     * @memberof Transaction
     */
    'cpuUsage': number;
    /**
     * 
     * @type {number}
     * @memberof Transaction
     */
    'fee': number;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface UpdateApikeyDto
 */
export interface UpdateApikeyDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateApikeyDto
     */
    'accessToken': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateApikeyDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateApikeyDto
     */
    'appName': string;
}
/**
 * 
 * @export
 * @interface UpdateDeveloperDto
 */
export interface UpdateDeveloperDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateDeveloperDto
     */
    'accessToken': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDeveloperDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDeveloperDto
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDeveloperDto
     */
    'currentPassword'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDeveloperDto
     */
    'subscribeNewsletter'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateWatchAddressDto
 */
export interface UpdateWatchAddressDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateWatchAddressDto
     */
    'accessToken': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateWatchAddressDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateWatchAddressDto
     */
    'description': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateWatchAddressDto
     */
    'notificationType': number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateWatchAddressDto
     */
    'trackERC20Transfer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateWatchAddressDto
     */
    'trackERC721Transfer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateWatchAddressDto
     */
    'trackERC1155Transfer': boolean;
}
/**
 * 
 * @export
 * @interface WatchAddress
 */
export interface WatchAddress {
    /**
     * 
     * @type {number}
     * @memberof WatchAddress
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof WatchAddress
     */
    'userID': number;
    /**
     * 
     * @type {string}
     * @memberof WatchAddress
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof WatchAddress
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof WatchAddress
     */
    'notificationType': number;
    /**
     * 
     * @type {boolean}
     * @memberof WatchAddress
     */
    'trackERC20Transfer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WatchAddress
     */
    'trackERC721Transfer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WatchAddress
     */
    'trackERC1155Transfer': boolean;
    /**
     * 
     * @type {string}
     * @memberof WatchAddress
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof WatchAddress
     */
    'updatedAt': string;
}

/**
 * APIKeyApi - axios parameter creator
 * @export
 */
export const APIKeyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new api key
         * @param {number} userID 
         * @param {CreateApikeyDto} createApikeyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createKey: async (userID: number, createApikeyDto: CreateApikeyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userID' is not null or undefined
            assertParamExists('createKey', 'userID', userID)
            // verify required parameter 'createApikeyDto' is not null or undefined
            assertParamExists('createKey', 'createApikeyDto', createApikeyDto)
            const localVarPath = `/apikey/{userID}`
                .replace(`{${"userID"}}`, encodeURIComponent(String(userID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createApikeyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get api keys
         * @param {string} userID 
         * @param {string} accessToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKeys: async (userID: string, accessToken: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userID' is not null or undefined
            assertParamExists('getKeys', 'userID', userID)
            // verify required parameter 'accessToken' is not null or undefined
            assertParamExists('getKeys', 'accessToken', accessToken)
            const localVarPath = `/apikey/{userID}`
                .replace(`{${"userID"}}`, encodeURIComponent(String(userID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (accessToken !== undefined) {
                localVarQueryParameter['accessToken'] = accessToken;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove api key
         * @param {string} userID 
         * @param {RemoveApikeyDto} removeApikeyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeKey: async (userID: string, removeApikeyDto: RemoveApikeyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userID' is not null or undefined
            assertParamExists('removeKey', 'userID', userID)
            // verify required parameter 'removeApikeyDto' is not null or undefined
            assertParamExists('removeKey', 'removeApikeyDto', removeApikeyDto)
            const localVarPath = `/apikey/{userID}`
                .replace(`{${"userID"}}`, encodeURIComponent(String(userID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(removeApikeyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update app name
         * @param {string} userID 
         * @param {UpdateApikeyDto} updateApikeyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateKey: async (userID: string, updateApikeyDto: UpdateApikeyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userID' is not null or undefined
            assertParamExists('updateKey', 'userID', userID)
            // verify required parameter 'updateApikeyDto' is not null or undefined
            assertParamExists('updateKey', 'updateApikeyDto', updateApikeyDto)
            const localVarPath = `/apikey/{userID}`
                .replace(`{${"userID"}}`, encodeURIComponent(String(userID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateApikeyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * APIKeyApi - functional programming interface
 * @export
 */
export const APIKeyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = APIKeyApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new api key
         * @param {number} userID 
         * @param {CreateApikeyDto} createApikeyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createKey(userID: number, createApikeyDto: CreateApikeyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Apikey>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createKey(userID, createApikeyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['APIKeyApi.createKey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get api keys
         * @param {string} userID 
         * @param {string} accessToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getKeys(userID: string, accessToken: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetKeys200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getKeys(userID, accessToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['APIKeyApi.getKeys']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove api key
         * @param {string} userID 
         * @param {RemoveApikeyDto} removeApikeyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeKey(userID: string, removeApikeyDto: RemoveApikeyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeKey(userID, removeApikeyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['APIKeyApi.removeKey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update app name
         * @param {string} userID 
         * @param {UpdateApikeyDto} updateApikeyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateKey(userID: string, updateApikeyDto: UpdateApikeyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Apikey>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateKey(userID, updateApikeyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['APIKeyApi.updateKey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * APIKeyApi - factory interface
 * @export
 */
export const APIKeyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = APIKeyApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new api key
         * @param {number} userID 
         * @param {CreateApikeyDto} createApikeyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createKey(userID: number, createApikeyDto: CreateApikeyDto, options?: any): AxiosPromise<Apikey> {
            return localVarFp.createKey(userID, createApikeyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get api keys
         * @param {string} userID 
         * @param {string} accessToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKeys(userID: string, accessToken: string, options?: any): AxiosPromise<GetKeys200Response> {
            return localVarFp.getKeys(userID, accessToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove api key
         * @param {string} userID 
         * @param {RemoveApikeyDto} removeApikeyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeKey(userID: string, removeApikeyDto: RemoveApikeyDto, options?: any): AxiosPromise<boolean> {
            return localVarFp.removeKey(userID, removeApikeyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update app name
         * @param {string} userID 
         * @param {UpdateApikeyDto} updateApikeyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateKey(userID: string, updateApikeyDto: UpdateApikeyDto, options?: any): AxiosPromise<Apikey> {
            return localVarFp.updateKey(userID, updateApikeyDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * APIKeyApi - object-oriented interface
 * @export
 * @class APIKeyApi
 * @extends {BaseAPI}
 */
export class APIKeyApi extends BaseAPI {
    /**
     * 
     * @summary Create a new api key
     * @param {number} userID 
     * @param {CreateApikeyDto} createApikeyDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIKeyApi
     */
    public createKey(userID: number, createApikeyDto: CreateApikeyDto, options?: RawAxiosRequestConfig) {
        return APIKeyApiFp(this.configuration).createKey(userID, createApikeyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get api keys
     * @param {string} userID 
     * @param {string} accessToken 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIKeyApi
     */
    public getKeys(userID: string, accessToken: string, options?: RawAxiosRequestConfig) {
        return APIKeyApiFp(this.configuration).getKeys(userID, accessToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove api key
     * @param {string} userID 
     * @param {RemoveApikeyDto} removeApikeyDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIKeyApi
     */
    public removeKey(userID: string, removeApikeyDto: RemoveApikeyDto, options?: RawAxiosRequestConfig) {
        return APIKeyApiFp(this.configuration).removeKey(userID, removeApikeyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update app name
     * @param {string} userID 
     * @param {UpdateApikeyDto} updateApikeyDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIKeyApi
     */
    public updateKey(userID: string, updateApikeyDto: UpdateApikeyDto, options?: RawAxiosRequestConfig) {
        return APIKeyApiFp(this.configuration).updateKey(userID, updateApikeyDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AccountsApi - axios parameter creator
 * @export
 */
export const AccountsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Account by name
         * @param {any} address Account Name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountByName: async (address: any, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'address' is not null or undefined
            assertParamExists('getAccountByName', 'address', address)
            const localVarPath = `/account/{address}`
                .replace(`{${"address"}}`, encodeURIComponent(String(address)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Accounts
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccounts: async (limit?: number, page?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccountsApi - functional programming interface
 * @export
 */
export const AccountsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AccountsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Account by name
         * @param {any} address Account Name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountByName(address: any, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Account>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountByName(address, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountsApi.getAccountByName']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Accounts
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccounts(limit?: number, page?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAccounts200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccounts(limit, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountsApi.getAccounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AccountsApi - factory interface
 * @export
 */
export const AccountsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AccountsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Account by name
         * @param {any} address Account Name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountByName(address: any, options?: any): AxiosPromise<Account> {
            return localVarFp.getAccountByName(address, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Accounts
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccounts(limit?: number, page?: number, options?: any): AxiosPromise<GetAccounts200Response> {
            return localVarFp.getAccounts(limit, page, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AccountsApi - object-oriented interface
 * @export
 * @class AccountsApi
 * @extends {BaseAPI}
 */
export class AccountsApi extends BaseAPI {
    /**
     * 
     * @summary Get Account by name
     * @param {any} address Account Name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    public getAccountByName(address: any, options?: RawAxiosRequestConfig) {
        return AccountsApiFp(this.configuration).getAccountByName(address, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Accounts
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    public getAccounts(limit?: number, page?: number, options?: RawAxiosRequestConfig) {
        return AccountsApiFp(this.configuration).getAccounts(limit, page, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BlocksApi - axios parameter creator
 * @export
 */
export const BlocksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Blocks
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlocks: async (limit?: number, page?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/block`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BlocksApi - functional programming interface
 * @export
 */
export const BlocksApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BlocksApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Blocks
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBlocks(limit?: number, page?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBlocks200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBlocks(limit, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BlocksApi.getBlocks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BlocksApi - factory interface
 * @export
 */
export const BlocksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BlocksApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Blocks
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlocks(limit?: number, page?: number, options?: any): AxiosPromise<GetBlocks200Response> {
            return localVarFp.getBlocks(limit, page, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BlocksApi - object-oriented interface
 * @export
 * @class BlocksApi
 * @extends {BaseAPI}
 */
export class BlocksApi extends BaseAPI {
    /**
     * 
     * @summary Get Blocks
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlocksApi
     */
    public getBlocks(limit?: number, page?: number, options?: RawAxiosRequestConfig) {
        return BlocksApiFp(this.configuration).getBlocks(limit, page, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ContractApi - axios parameter creator
 * @export
 */
export const ContractApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contractControllerCreate: async (body: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('contractControllerCreate', 'body', body)
            const localVarPath = `/contract`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contractControllerFindAll: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/contract`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contractControllerRemove: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('contractControllerRemove', 'id', id)
            const localVarPath = `/contract/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contractControllerUpdate: async (id: string, body: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('contractControllerUpdate', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('contractControllerUpdate', 'body', body)
            const localVarPath = `/contract/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Contract
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContract: async (name: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('getContract', 'name', name)
            const localVarPath = `/contract/{name}`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verify Smart Contract
         * @param {string} name 
         * @param {string} entryFileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyContract: async (name: string, entryFileName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('verifyContract', 'name', name)
            // verify required parameter 'entryFileName' is not null or undefined
            assertParamExists('verifyContract', 'entryFileName', entryFileName)
            const localVarPath = `/contract/verify/{name}`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (entryFileName !== undefined) { 
                localVarFormParams.append('entryFileName', entryFileName as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContractApi - functional programming interface
 * @export
 */
export const ContractApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContractApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async contractControllerCreate(body: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.contractControllerCreate(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractApi.contractControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async contractControllerFindAll(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.contractControllerFindAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractApi.contractControllerFindAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async contractControllerRemove(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.contractControllerRemove(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractApi.contractControllerRemove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async contractControllerUpdate(id: string, body: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.contractControllerUpdate(id, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractApi.contractControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Contract
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContract(name: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Contract>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContract(name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractApi.getContract']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Verify Smart Contract
         * @param {string} name 
         * @param {string} entryFileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyContract(name: string, entryFileName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyContract(name, entryFileName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractApi.verifyContract']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ContractApi - factory interface
 * @export
 */
export const ContractApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContractApiFp(configuration)
    return {
        /**
         * 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contractControllerCreate(body: object, options?: any): AxiosPromise<void> {
            return localVarFp.contractControllerCreate(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contractControllerFindAll(options?: any): AxiosPromise<void> {
            return localVarFp.contractControllerFindAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contractControllerRemove(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.contractControllerRemove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contractControllerUpdate(id: string, body: object, options?: any): AxiosPromise<void> {
            return localVarFp.contractControllerUpdate(id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Contract
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContract(name: string, options?: any): AxiosPromise<Contract> {
            return localVarFp.getContract(name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verify Smart Contract
         * @param {string} name 
         * @param {string} entryFileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyContract(name: string, entryFileName: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.verifyContract(name, entryFileName, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ContractApi - object-oriented interface
 * @export
 * @class ContractApi
 * @extends {BaseAPI}
 */
export class ContractApi extends BaseAPI {
    /**
     * 
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractApi
     */
    public contractControllerCreate(body: object, options?: RawAxiosRequestConfig) {
        return ContractApiFp(this.configuration).contractControllerCreate(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractApi
     */
    public contractControllerFindAll(options?: RawAxiosRequestConfig) {
        return ContractApiFp(this.configuration).contractControllerFindAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractApi
     */
    public contractControllerRemove(id: string, options?: RawAxiosRequestConfig) {
        return ContractApiFp(this.configuration).contractControllerRemove(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractApi
     */
    public contractControllerUpdate(id: string, body: object, options?: RawAxiosRequestConfig) {
        return ContractApiFp(this.configuration).contractControllerUpdate(id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Contract
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractApi
     */
    public getContract(name: string, options?: RawAxiosRequestConfig) {
        return ContractApiFp(this.configuration).getContract(name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verify Smart Contract
     * @param {string} name 
     * @param {string} entryFileName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractApi
     */
    public verifyContract(name: string, entryFileName: string, options?: RawAxiosRequestConfig) {
        return ContractApiFp(this.configuration).verifyContract(name, entryFileName, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DeveloperApi - axios parameter creator
 * @export
 */
export const DeveloperApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete developer account
         * @param {string} id 
         * @param {AuthParam} authParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDeveloper: async (id: string, authParam: AuthParam, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteDeveloper', 'id', id)
            // verify required parameter 'authParam' is not null or undefined
            assertParamExists('deleteDeveloper', 'authParam', authParam)
            const localVarPath = `/developer/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(authParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get developer information
         * @param {string} id 
         * @param {string} accessToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInformation: async (id: string, accessToken: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getInformation', 'id', id)
            // verify required parameter 'accessToken' is not null or undefined
            assertParamExists('getInformation', 'accessToken', accessToken)
            const localVarPath = `/developer/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (accessToken !== undefined) {
                localVarQueryParameter['accessToken'] = accessToken;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Signin Developer account
         * @param {LoginDeveloperDto} loginDeveloperDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signin: async (loginDeveloperDto: LoginDeveloperDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginDeveloperDto' is not null or undefined
            assertParamExists('signin', 'loginDeveloperDto', loginDeveloperDto)
            const localVarPath = `/developer/signin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginDeveloperDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Signup Developer account
         * @param {CreateDeveloperDto} createDeveloperDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signup: async (createDeveloperDto: CreateDeveloperDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createDeveloperDto' is not null or undefined
            assertParamExists('signup', 'createDeveloperDto', createDeveloperDto)
            const localVarPath = `/developer/signup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDeveloperDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update developer information
         * @param {string} id 
         * @param {UpdateDeveloperDto} updateDeveloperDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInformation: async (id: string, updateDeveloperDto: UpdateDeveloperDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateInformation', 'id', id)
            // verify required parameter 'updateDeveloperDto' is not null or undefined
            assertParamExists('updateInformation', 'updateDeveloperDto', updateDeveloperDto)
            const localVarPath = `/developer/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDeveloperDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DeveloperApi - functional programming interface
 * @export
 */
export const DeveloperApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DeveloperApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete developer account
         * @param {string} id 
         * @param {AuthParam} authParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDeveloper(id: string, authParam: AuthParam, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDeveloper(id, authParam, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeveloperApi.deleteDeveloper']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get developer information
         * @param {string} id 
         * @param {string} accessToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInformation(id: string, accessToken: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeveloperInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInformation(id, accessToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeveloperApi.getInformation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Signin Developer account
         * @param {LoginDeveloperDto} loginDeveloperDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signin(loginDeveloperDto: LoginDeveloperDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Signin200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signin(loginDeveloperDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeveloperApi.signin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Signup Developer account
         * @param {CreateDeveloperDto} createDeveloperDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signup(createDeveloperDto: CreateDeveloperDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeveloperInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signup(createDeveloperDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeveloperApi.signup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update developer information
         * @param {string} id 
         * @param {UpdateDeveloperDto} updateDeveloperDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateInformation(id: string, updateDeveloperDto: UpdateDeveloperDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeveloperInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateInformation(id, updateDeveloperDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeveloperApi.updateInformation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DeveloperApi - factory interface
 * @export
 */
export const DeveloperApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DeveloperApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete developer account
         * @param {string} id 
         * @param {AuthParam} authParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDeveloper(id: string, authParam: AuthParam, options?: any): AxiosPromise<boolean> {
            return localVarFp.deleteDeveloper(id, authParam, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get developer information
         * @param {string} id 
         * @param {string} accessToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInformation(id: string, accessToken: string, options?: any): AxiosPromise<DeveloperInfo> {
            return localVarFp.getInformation(id, accessToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Signin Developer account
         * @param {LoginDeveloperDto} loginDeveloperDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signin(loginDeveloperDto: LoginDeveloperDto, options?: any): AxiosPromise<Signin200Response> {
            return localVarFp.signin(loginDeveloperDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Signup Developer account
         * @param {CreateDeveloperDto} createDeveloperDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signup(createDeveloperDto: CreateDeveloperDto, options?: any): AxiosPromise<DeveloperInfo> {
            return localVarFp.signup(createDeveloperDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update developer information
         * @param {string} id 
         * @param {UpdateDeveloperDto} updateDeveloperDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInformation(id: string, updateDeveloperDto: UpdateDeveloperDto, options?: any): AxiosPromise<DeveloperInfo> {
            return localVarFp.updateInformation(id, updateDeveloperDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DeveloperApi - object-oriented interface
 * @export
 * @class DeveloperApi
 * @extends {BaseAPI}
 */
export class DeveloperApi extends BaseAPI {
    /**
     * 
     * @summary Delete developer account
     * @param {string} id 
     * @param {AuthParam} authParam 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeveloperApi
     */
    public deleteDeveloper(id: string, authParam: AuthParam, options?: RawAxiosRequestConfig) {
        return DeveloperApiFp(this.configuration).deleteDeveloper(id, authParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get developer information
     * @param {string} id 
     * @param {string} accessToken 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeveloperApi
     */
    public getInformation(id: string, accessToken: string, options?: RawAxiosRequestConfig) {
        return DeveloperApiFp(this.configuration).getInformation(id, accessToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Signin Developer account
     * @param {LoginDeveloperDto} loginDeveloperDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeveloperApi
     */
    public signin(loginDeveloperDto: LoginDeveloperDto, options?: RawAxiosRequestConfig) {
        return DeveloperApiFp(this.configuration).signin(loginDeveloperDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Signup Developer account
     * @param {CreateDeveloperDto} createDeveloperDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeveloperApi
     */
    public signup(createDeveloperDto: CreateDeveloperDto, options?: RawAxiosRequestConfig) {
        return DeveloperApiFp(this.configuration).signup(createDeveloperDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update developer information
     * @param {string} id 
     * @param {UpdateDeveloperDto} updateDeveloperDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeveloperApi
     */
    public updateInformation(id: string, updateDeveloperDto: UpdateDeveloperDto, options?: RawAxiosRequestConfig) {
        return DeveloperApiFp(this.configuration).updateInformation(id, updateDeveloperDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LoginHistoryApi - axios parameter creator
 * @export
 */
export const LoginHistoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get loggedin history of developer
         * @param {string} id 
         * @param {string} accessToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLastLoggedInHistory: async (id: string, accessToken: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getLastLoggedInHistory', 'id', id)
            // verify required parameter 'accessToken' is not null or undefined
            assertParamExists('getLastLoggedInHistory', 'accessToken', accessToken)
            const localVarPath = `/login-history/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (accessToken !== undefined) {
                localVarQueryParameter['accessToken'] = accessToken;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LoginHistoryApi - functional programming interface
 * @export
 */
export const LoginHistoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LoginHistoryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get loggedin history of developer
         * @param {string} id 
         * @param {string} accessToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLastLoggedInHistory(id: string, accessToken: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLastLoggedInHistory200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLastLoggedInHistory(id, accessToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoginHistoryApi.getLastLoggedInHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LoginHistoryApi - factory interface
 * @export
 */
export const LoginHistoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LoginHistoryApiFp(configuration)
    return {
        /**
         * 
         * @summary Get loggedin history of developer
         * @param {string} id 
         * @param {string} accessToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLastLoggedInHistory(id: string, accessToken: string, options?: any): AxiosPromise<GetLastLoggedInHistory200Response> {
            return localVarFp.getLastLoggedInHistory(id, accessToken, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LoginHistoryApi - object-oriented interface
 * @export
 * @class LoginHistoryApi
 * @extends {BaseAPI}
 */
export class LoginHistoryApi extends BaseAPI {
    /**
     * 
     * @summary Get loggedin history of developer
     * @param {string} id 
     * @param {string} accessToken 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginHistoryApi
     */
    public getLastLoggedInHistory(id: string, accessToken: string, options?: RawAxiosRequestConfig) {
        return LoginHistoryApiFp(this.configuration).getLastLoggedInHistory(id, accessToken, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * QuotesApi - axios parameter creator
 * @export
 */
export const QuotesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Token Quotes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllQuotes: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/quote/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Token Quotes
         * @param {string} tokenName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTokenQuote: async (tokenName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tokenName' is not null or undefined
            assertParamExists('getTokenQuote', 'tokenName', tokenName)
            const localVarPath = `/quote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (tokenName !== undefined) {
                localVarQueryParameter['tokenName'] = tokenName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QuotesApi - functional programming interface
 * @export
 */
export const QuotesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QuotesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Token Quotes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllQuotes(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Quote>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllQuotes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuotesApi.getAllQuotes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Token Quotes
         * @param {string} tokenName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTokenQuote(tokenName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Quote>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTokenQuote(tokenName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuotesApi.getTokenQuote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * QuotesApi - factory interface
 * @export
 */
export const QuotesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QuotesApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Token Quotes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllQuotes(options?: any): AxiosPromise<Array<Quote>> {
            return localVarFp.getAllQuotes(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Token Quotes
         * @param {string} tokenName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTokenQuote(tokenName: string, options?: any): AxiosPromise<Array<Quote>> {
            return localVarFp.getTokenQuote(tokenName, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QuotesApi - object-oriented interface
 * @export
 * @class QuotesApi
 * @extends {BaseAPI}
 */
export class QuotesApi extends BaseAPI {
    /**
     * 
     * @summary Get Token Quotes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuotesApi
     */
    public getAllQuotes(options?: RawAxiosRequestConfig) {
        return QuotesApiFp(this.configuration).getAllQuotes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Token Quotes
     * @param {string} tokenName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuotesApi
     */
    public getTokenQuote(tokenName: string, options?: RawAxiosRequestConfig) {
        return QuotesApiFp(this.configuration).getTokenQuote(tokenName, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TokensApi - axios parameter creator
 * @export
 */
export const TokensApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Tokens
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTokens: async (limit?: number, page?: number, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TokensApi - functional programming interface
 * @export
 */
export const TokensApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TokensApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Tokens
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTokens(limit?: number, page?: number, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTokens200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTokens(limit, page, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TokensApi.getTokens']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TokensApi - factory interface
 * @export
 */
export const TokensApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TokensApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Tokens
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTokens(limit?: number, page?: number, search?: string, options?: any): AxiosPromise<GetTokens200Response> {
            return localVarFp.getTokens(limit, page, search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TokensApi - object-oriented interface
 * @export
 * @class TokensApi
 * @extends {BaseAPI}
 */
export class TokensApi extends BaseAPI {
    /**
     * 
     * @summary Get Tokens
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokensApi
     */
    public getTokens(limit?: number, page?: number, search?: string, options?: RawAxiosRequestConfig) {
        return TokensApiFp(this.configuration).getTokens(limit, page, search, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TransactionsApi - axios parameter creator
 * @export
 */
export const TransactionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get first and last transaction sent by account
         * @param {string} account Account ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFALTransactions: async (account: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'account' is not null or undefined
            assertParamExists('getFALTransactions', 'account', account)
            const localVarPath = `/tx/falTxs/{account}`
                .replace(`{${"account"}}`, encodeURIComponent(String(account)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get transactions
         * @param {string} [type] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactions: async (type?: string, limit?: number, page?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/tx`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get transactions by account id
         * @param {string} accountId Account ID
         * @param {number} lastBlock 
         * @param {string} [token] 
         * @param {string} [txType] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [order] 
         * @param {string} [sort] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionsByAccount: async (accountId: string, lastBlock: number, token?: string, txType?: string, limit?: number, page?: number, order?: string, sort?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('getTransactionsByAccount', 'accountId', accountId)
            // verify required parameter 'lastBlock' is not null or undefined
            assertParamExists('getTransactionsByAccount', 'lastBlock', lastBlock)
            const localVarPath = `/tx/history/{accountId}`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (lastBlock !== undefined) {
                localVarQueryParameter['lastBlock'] = lastBlock;
            }

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }

            if (txType !== undefined) {
                localVarQueryParameter['txType'] = txType;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get transactions by date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionsByDate: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/tx/bydate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get transactions by id
         * @param {string} txId Tx ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionsById: async (txId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'txId' is not null or undefined
            assertParamExists('getTransactionsById', 'txId', txId)
            const localVarPath = `/tx/{txId}`
                .replace(`{${"txId"}}`, encodeURIComponent(String(txId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TransactionsApi - functional programming interface
 * @export
 */
export const TransactionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TransactionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get first and last transaction sent by account
         * @param {string} account Account ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFALTransactions(account: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Transaction>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFALTransactions(account, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransactionsApi.getFALTransactions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get transactions
         * @param {string} [type] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransactions(type?: string, limit?: number, page?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTransactions200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTransactions(type, limit, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransactionsApi.getTransactions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get transactions by account id
         * @param {string} accountId Account ID
         * @param {number} lastBlock 
         * @param {string} [token] 
         * @param {string} [txType] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [order] 
         * @param {string} [sort] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransactionsByAccount(accountId: string, lastBlock: number, token?: string, txType?: string, limit?: number, page?: number, order?: string, sort?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTransactions200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTransactionsByAccount(accountId, lastBlock, token, txType, limit, page, order, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransactionsApi.getTransactionsByAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get transactions by date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransactionsByDate(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ChartDataDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTransactionsByDate(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransactionsApi.getTransactionsByDate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get transactions by id
         * @param {string} txId Tx ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransactionsById(txId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Transaction>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTransactionsById(txId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransactionsApi.getTransactionsById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TransactionsApi - factory interface
 * @export
 */
export const TransactionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TransactionsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get first and last transaction sent by account
         * @param {string} account Account ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFALTransactions(account: string, options?: any): AxiosPromise<Array<Transaction>> {
            return localVarFp.getFALTransactions(account, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get transactions
         * @param {string} [type] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactions(type?: string, limit?: number, page?: number, options?: any): AxiosPromise<GetTransactions200Response> {
            return localVarFp.getTransactions(type, limit, page, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get transactions by account id
         * @param {string} accountId Account ID
         * @param {number} lastBlock 
         * @param {string} [token] 
         * @param {string} [txType] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [order] 
         * @param {string} [sort] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionsByAccount(accountId: string, lastBlock: number, token?: string, txType?: string, limit?: number, page?: number, order?: string, sort?: string, options?: any): AxiosPromise<GetTransactions200Response> {
            return localVarFp.getTransactionsByAccount(accountId, lastBlock, token, txType, limit, page, order, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get transactions by date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionsByDate(options?: any): AxiosPromise<Array<ChartDataDto>> {
            return localVarFp.getTransactionsByDate(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get transactions by id
         * @param {string} txId Tx ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionsById(txId: string, options?: any): AxiosPromise<Transaction> {
            return localVarFp.getTransactionsById(txId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TransactionsApi - object-oriented interface
 * @export
 * @class TransactionsApi
 * @extends {BaseAPI}
 */
export class TransactionsApi extends BaseAPI {
    /**
     * 
     * @summary Get first and last transaction sent by account
     * @param {string} account Account ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public getFALTransactions(account: string, options?: RawAxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).getFALTransactions(account, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get transactions
     * @param {string} [type] 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public getTransactions(type?: string, limit?: number, page?: number, options?: RawAxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).getTransactions(type, limit, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get transactions by account id
     * @param {string} accountId Account ID
     * @param {number} lastBlock 
     * @param {string} [token] 
     * @param {string} [txType] 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string} [order] 
     * @param {string} [sort] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public getTransactionsByAccount(accountId: string, lastBlock: number, token?: string, txType?: string, limit?: number, page?: number, order?: string, sort?: string, options?: RawAxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).getTransactionsByAccount(accountId, lastBlock, token, txType, limit, page, order, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get transactions by date
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public getTransactionsByDate(options?: RawAxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).getTransactionsByDate(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get transactions by id
     * @param {string} txId Tx ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public getTransactionsById(txId: string, options?: RawAxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).getTransactionsById(txId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WatchAddressApi - axios parameter creator
 * @export
 */
export const WatchAddressApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add a watch address
         * @param {number} userID 
         * @param {CreateWatchAddressDto} createWatchAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAddress: async (userID: number, createWatchAddressDto: CreateWatchAddressDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userID' is not null or undefined
            assertParamExists('addAddress', 'userID', userID)
            // verify required parameter 'createWatchAddressDto' is not null or undefined
            assertParamExists('addAddress', 'createWatchAddressDto', createWatchAddressDto)
            const localVarPath = `/watch-address/{userID}`
                .replace(`{${"userID"}}`, encodeURIComponent(String(userID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createWatchAddressDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get watch addresses
         * @param {number} userID 
         * @param {string} accessToken 
         * @param {number} offset 
         * @param {number} limit 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWatchAddresses: async (userID: number, accessToken: string, offset: number, limit: number, keyword?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userID' is not null or undefined
            assertParamExists('getWatchAddresses', 'userID', userID)
            // verify required parameter 'accessToken' is not null or undefined
            assertParamExists('getWatchAddresses', 'accessToken', accessToken)
            // verify required parameter 'offset' is not null or undefined
            assertParamExists('getWatchAddresses', 'offset', offset)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getWatchAddresses', 'limit', limit)
            const localVarPath = `/watch-address/{userID}`
                .replace(`{${"userID"}}`, encodeURIComponent(String(userID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (accessToken !== undefined) {
                localVarQueryParameter['accessToken'] = accessToken;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove watch address
         * @param {number} userID 
         * @param {RemoveWatchAddressDto} removeWatchAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAddress: async (userID: number, removeWatchAddressDto: RemoveWatchAddressDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userID' is not null or undefined
            assertParamExists('removeAddress', 'userID', userID)
            // verify required parameter 'removeWatchAddressDto' is not null or undefined
            assertParamExists('removeAddress', 'removeWatchAddressDto', removeWatchAddressDto)
            const localVarPath = `/watch-address/{userID}`
                .replace(`{${"userID"}}`, encodeURIComponent(String(userID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(removeWatchAddressDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update watch address
         * @param {string} userID 
         * @param {UpdateWatchAddressDto} updateWatchAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAddress: async (userID: string, updateWatchAddressDto: UpdateWatchAddressDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userID' is not null or undefined
            assertParamExists('updateAddress', 'userID', userID)
            // verify required parameter 'updateWatchAddressDto' is not null or undefined
            assertParamExists('updateAddress', 'updateWatchAddressDto', updateWatchAddressDto)
            const localVarPath = `/watch-address/{userID}`
                .replace(`{${"userID"}}`, encodeURIComponent(String(userID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateWatchAddressDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WatchAddressApi - functional programming interface
 * @export
 */
export const WatchAddressApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WatchAddressApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add a watch address
         * @param {number} userID 
         * @param {CreateWatchAddressDto} createWatchAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addAddress(userID: number, createWatchAddressDto: CreateWatchAddressDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WatchAddress>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addAddress(userID, createWatchAddressDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WatchAddressApi.addAddress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get watch addresses
         * @param {number} userID 
         * @param {string} accessToken 
         * @param {number} offset 
         * @param {number} limit 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWatchAddresses(userID: number, accessToken: string, offset: number, limit: number, keyword?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetWatchAddresses200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWatchAddresses(userID, accessToken, offset, limit, keyword, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WatchAddressApi.getWatchAddresses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove watch address
         * @param {number} userID 
         * @param {RemoveWatchAddressDto} removeWatchAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeAddress(userID: number, removeWatchAddressDto: RemoveWatchAddressDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeAddress(userID, removeWatchAddressDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WatchAddressApi.removeAddress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update watch address
         * @param {string} userID 
         * @param {UpdateWatchAddressDto} updateWatchAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAddress(userID: string, updateWatchAddressDto: UpdateWatchAddressDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WatchAddress>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAddress(userID, updateWatchAddressDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WatchAddressApi.updateAddress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WatchAddressApi - factory interface
 * @export
 */
export const WatchAddressApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WatchAddressApiFp(configuration)
    return {
        /**
         * 
         * @summary Add a watch address
         * @param {number} userID 
         * @param {CreateWatchAddressDto} createWatchAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAddress(userID: number, createWatchAddressDto: CreateWatchAddressDto, options?: any): AxiosPromise<WatchAddress> {
            return localVarFp.addAddress(userID, createWatchAddressDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get watch addresses
         * @param {number} userID 
         * @param {string} accessToken 
         * @param {number} offset 
         * @param {number} limit 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWatchAddresses(userID: number, accessToken: string, offset: number, limit: number, keyword?: string, options?: any): AxiosPromise<GetWatchAddresses200Response> {
            return localVarFp.getWatchAddresses(userID, accessToken, offset, limit, keyword, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove watch address
         * @param {number} userID 
         * @param {RemoveWatchAddressDto} removeWatchAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAddress(userID: number, removeWatchAddressDto: RemoveWatchAddressDto, options?: any): AxiosPromise<boolean> {
            return localVarFp.removeAddress(userID, removeWatchAddressDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update watch address
         * @param {string} userID 
         * @param {UpdateWatchAddressDto} updateWatchAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAddress(userID: string, updateWatchAddressDto: UpdateWatchAddressDto, options?: any): AxiosPromise<WatchAddress> {
            return localVarFp.updateAddress(userID, updateWatchAddressDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WatchAddressApi - object-oriented interface
 * @export
 * @class WatchAddressApi
 * @extends {BaseAPI}
 */
export class WatchAddressApi extends BaseAPI {
    /**
     * 
     * @summary Add a watch address
     * @param {number} userID 
     * @param {CreateWatchAddressDto} createWatchAddressDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WatchAddressApi
     */
    public addAddress(userID: number, createWatchAddressDto: CreateWatchAddressDto, options?: RawAxiosRequestConfig) {
        return WatchAddressApiFp(this.configuration).addAddress(userID, createWatchAddressDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get watch addresses
     * @param {number} userID 
     * @param {string} accessToken 
     * @param {number} offset 
     * @param {number} limit 
     * @param {string} [keyword] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WatchAddressApi
     */
    public getWatchAddresses(userID: number, accessToken: string, offset: number, limit: number, keyword?: string, options?: RawAxiosRequestConfig) {
        return WatchAddressApiFp(this.configuration).getWatchAddresses(userID, accessToken, offset, limit, keyword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove watch address
     * @param {number} userID 
     * @param {RemoveWatchAddressDto} removeWatchAddressDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WatchAddressApi
     */
    public removeAddress(userID: number, removeWatchAddressDto: RemoveWatchAddressDto, options?: RawAxiosRequestConfig) {
        return WatchAddressApiFp(this.configuration).removeAddress(userID, removeWatchAddressDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update watch address
     * @param {string} userID 
     * @param {UpdateWatchAddressDto} updateWatchAddressDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WatchAddressApi
     */
    public updateAddress(userID: string, updateWatchAddressDto: UpdateWatchAddressDto, options?: RawAxiosRequestConfig) {
        return WatchAddressApiFp(this.configuration).updateAddress(userID, updateWatchAddressDto, options).then((request) => request(this.axios, this.basePath));
    }
}



